import { actionTypes } from './actions';
import initialState from './initialState';

export default function externalTaxAuthorityReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state.set('loading', true).set('error', null);
    case actionTypes.REQUEST_SUCCESS:
      return state.set('loading', false).set('data', mapTaxAuthorities(state, action.payload));
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    default:
      return state;
  }
}

function mapTaxAuthorities(state, payload) {
  const taxCode = payload ? payload.codeSOUN : null;
  const data = state.get('data');

  return data.set(taxCode, payload);
}
